import { IAutoMapper } from "../interfaces";

export const mapMemberChartItem = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MemberChartItem")
    .forMember("chartId", o => o.chartId)
    .forMember("tenantId", o => o.tenantId)
    .forMember("chartType", o => o.chartType)
    .forMember("memberId", o => o.memberId)
    .forMember("firstName", o => o.firstName)
    .forMember("lastName", o => o.lastName)
    .forMember("createTs", o => o.createTs)
    .forMember("updateTs", o => o.updateTs)
    .forMember("dob", o => o.dob)
    .forMember("memberConflictFlag", o => o.memberConflictFlag)
    .forMember("sourceSystem", o => o.sourceSystem)
    .forMember("totalPageCount", o => o.totalPageCount)
    .forMember("fileName", o => o.fileName)
    .forMember("trackingNumber", o => o.trackingNumber)
    .forMember("dateOfServiceFrom", o => o.dateOfServiceFrom)
    .forMember("dateOfServiceTo", o => o.dateOfServiceTo)
    .forMember("dateOfServiceRange", o => o.dateOfServiceRange)
    .forMember("providerName", o => o.providerName)
    .forMember("groupName", o => o.groupName);

};
